import React from "react";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";

interface ExportToExcelProps {
  data: Record<string, any>[]; // More specific type for data
  fileName?: string;
}

const ExportToExcel: React.FC<ExportToExcelProps> = ({
  data,
  fileName = "exported_data",
}) => {
  const exportFile = () => {
    if (data.length === 0) {
      alert("No data available to export.");
      return;
    }

    try {
      // Create worksheet and workbook
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const file = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(file, `${fileName}.xlsx`);
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      alert("An error occurred while exporting the data.");
    }
  };

  return (
    <button
      onClick={exportFile}
      className="btn btn-primary"
      aria-label="Export to Excel"
      title="Export to Excel"
    >
      Export to Excel
    </button>
  );
};

export default ExportToExcel;